import { atom } from 'recoil';

export const isInternetReachableState = atom<boolean>({
  default: true,
  key: 'isInternetReachableState',
});
